import React, { useState } from 'react'
import classes from './styles.module.scss'

const Switch = ({ activeTab, handleClick }) => {

    const [selectedTab, setSelectedTab] = useState(0);
    const location = ['Gaya','Patna']
    return (
        <div className={classes.wrap} >
            {
                location.map((e, i) => (
                    <div className={classes.patna} style={{ backgroundColor: i === activeTab ? "#AF2910" : "white", color: i === activeTab ? "white" : "black" }} onClick={() => { setSelectedTab(i); handleClick(i) }} >
                        {e === 'Gaya' ? 'Gaya' : e}
                    </div>
                ))
            }

        </div>
    )
}

export default Switch
